import { render } from "./editbrand.vue?vue&type=template&id=d149bc8e"
import script from "./editbrand.vue?vue&type=script&lang=js"
export * from "./editbrand.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-MakProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__